/**
 * Patio leaves-e165 — left Umbrella (natural ratio, height-matched to right)
 * + right 3×2 small 1:1 cards (两横三列). Never build without Umbrella image.
 */
(function () {
  'use strict';

  if (!document.body || document.documentElement.dataset.leavesPatioEiskuBoot === '1') return;
  document.documentElement.dataset.leavesPatioEiskuBoot = '1';

  var SECTION_ID = 'leaves-e165';
  var TITLE_MATCH = /patio feel special/i;
  var SCENE_ORDER = ['Umbrella', 'Tree', 'Ceiling', 'Grass', 'Balcony', 'Wall', 'Fence'];

  function textOf(node) {
    return String((node && node.textContent) || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function hideOriginal(node) {
    if (!node) return;
    node.classList.add('leaves-original-replaced');
    node.setAttribute('aria-hidden', 'true');
    node.setAttribute('hidden', '');
  }

  function findSection() {
    var byId = document.querySelector('#leaves-home [data-section-id="' + SECTION_ID + '"]');
    if (byId) return byId;
    var headings = document.querySelectorAll('#leaves-home [data-leaves-type="FlexSection"] h3');
    for (var i = 0; i < headings.length; i += 1) {
      if (TITLE_MATCH.test(textOf(headings[i]))) {
        return headings[i].closest('[data-leaves-type="FlexSection"]');
      }
    }
    return null;
  }

  function moveAboveVideo(section) {
    if (typeof window.leavesPlaceHomeSections === 'function') {
      window.leavesPlaceHomeSections();
      return;
    }
    var video = document.querySelector('#leaves-home [data-section-id="leaves-26b5"]');
    if (!video || !section || !video.parentNode) return;
    var factory =
      document.querySelector('#leaves-home .leaves-fn-joby-host') ||
      document.querySelector('#leaves-home [data-section-id="leaves-373f"]') ||
      document.querySelector('#leaves-home .leaves-sohub-awards-host') ||
      document.querySelector('#leaves-home [data-section-id="leaves-1e60"]');
    var anchor = factory && factory.parentNode === video.parentNode ? factory : video;
    if (section.nextElementSibling === anchor) return;
    anchor.parentNode.insertBefore(section, anchor);
  }

  function extractUrl(value) {
    if (!value || value === 'none') return '';
    var m = String(value).match(/url\(["']?([^"')]+)["']?\)/i);
    return m ? m[1].replace(/&quot;/g, '"').replace(/&amp;/g, '&') : '';
  }

  function bgFromStyleText(classTokens) {
    if (!classTokens || !classTokens.length) return '';
    var tags = document.querySelectorAll('style');
    var i;
    var t;
    var text;
    var token;
    var re;
    var m;
    for (i = 0; i < tags.length; i += 1) {
      text = tags[i].textContent || '';
      if (!text || text.indexOf('background') === -1) continue;
      for (t = 0; t < classTokens.length; t += 1) {
        token = classTokens[t];
        if (text.indexOf(token) === -1) continue;
        re = new RegExp(
          '\\.' + token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
            '[^{}]*\\{[^}]*background(?:-image)?\\s*:\\s*([^;}]+)',
          'i'
        );
        m = text.match(re);
        if (m) {
          var url = extractUrl(m[1]);
          if (url) return url;
        }
      }
    }
    return '';
  }

  function bgFromSheets(node) {
    if (!node || !node.className) return '';
    var tokens = String(node.className)
      .split(/\s+/)
      .filter(function (c) {
        return /^leaves-\w/.test(c) || /^sc-/.test(c);
      });
    if (!tokens.length) return '';

    var fromText = bgFromStyleText(tokens);
    if (fromText) return fromText;

    var sheets = document.styleSheets;
    for (var s = 0; s < sheets.length; s += 1) {
      var rules;
      try {
        rules = sheets[s].cssRules;
      } catch (err) {
        continue;
      }
      if (!rules) continue;
      for (var r = 0; r < rules.length; r += 1) {
        var rule = rules[r];
        if (!rule.selectorText || !rule.style) continue;
        var hit = false;
        for (var t = 0; t < tokens.length; t += 1) {
          if (rule.selectorText.indexOf(tokens[t]) !== -1) {
            hit = true;
            break;
          }
        }
        if (!hit) continue;
        var bg = extractUrl(rule.style.backgroundImage);
        if (bg) return bg;
      }
    }
    return '';
  }

  function bgUrlFrom(node) {
    if (!node) return '';
    var img = node.querySelector('img');
    if (img) {
      var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
      if (src && src.indexOf('{{') === -1) return src;
    }

    var targets = [];
    if (node.classList && (node.classList.contains('leaves-bg-lazy') || node.getAttribute('style'))) {
      targets.push(node);
    }
    Array.prototype.forEach.call(
      node.querySelectorAll('.leaves-bg-lazy, [style*="background"], [data-bg], [data-src]'),
      function (el) {
        targets.push(el);
      }
    );
    if (!targets.length) targets.push(node);

    for (var i = 0; i < targets.length; i += 1) {
      var el = targets[i];
      var dataBg =
        el.getAttribute('data-bg') ||
        el.getAttribute('data-src') ||
        el.getAttribute('data-background') ||
        '';
      if (dataBg && /^https?:/.test(dataBg)) return dataBg;

      var fromAttr = extractUrl(el.getAttribute('style') || '');
      if (fromAttr) return fromAttr;

      var fromSheet = bgFromSheets(el);
      if (fromSheet) return fromSheet;

      var hadLazy = el.classList.contains('leaves-bg-lazy');
      if (hadLazy) el.classList.remove('leaves-bg-lazy');
      var fromCs = extractUrl(window.getComputedStyle(el).backgroundImage);
      if (hadLazy) el.classList.add('leaves-bg-lazy');
      if (fromCs) return fromCs;
    }
    return bgFromSheets(node) || bgFromStyleText(
      String(node.className || '')
        .split(/\s+/)
        .filter(function (c) {
          return /^leaves-\w/.test(c);
        })
    );
  }

  function findSceneNode(section, title) {
    var headings = section.querySelectorAll('h3, h4, [data-leaves-type="Heading2"], [data-leaves-type="Heading4"]');
    var re = new RegExp('^\\s*' + title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$', 'i');
    for (var i = 0; i < headings.length; i += 1) {
      if (!re.test(textOf(headings[i]))) continue;
      if (TITLE_MATCH.test(textOf(headings[i]))) continue;
      var node =
        headings[i].closest('[data-leaves-type="ContentListItem"]') ||
        headings[i].closest('.leaves-bg-lazy') ||
        headings[i].closest('[data-leaves-type="FlexBlock"]') ||
        headings[i].parentElement;
      if (node && !node.closest('.leaves-patio-eisku')) return node;
    }
    return null;
  }

  function collectScenes(section) {
    var scenes = [];
    var i;
    var title;
    var node;
    var href;
    var image;

    for (i = 0; i < SCENE_ORDER.length; i += 1) {
      title = SCENE_ORDER[i];
      node = findSceneNode(section, title);
      if (!node) continue;
      href =
        node.getAttribute('data-href') ||
        (node.querySelector('a[href]') && node.querySelector('a[href]').getAttribute('href')) ||
        '';
      if (!href || href === '#') href = '/search?q=' + encodeURIComponent(title);
      image = bgUrlFrom(node);
      scenes.push({ title: title, href: href, image: image, node: node });
    }
    return scenes;
  }

  function pickFeatured(scenes) {
    var i;
    for (i = 0; i < scenes.length; i += 1) {
      if (/umbrella/i.test(scenes[i].title) && scenes[i].image) return scenes[i];
    }
    return null;
  }

  function cellHtml(scene, featured, clone) {
    if (!scene) return '';
    var img = scene.image
      ? '<img src="' +
        escapeAttr(scene.image) +
        '" alt="' +
        escapeAttr(scene.title) +
        '" loading="eager" decoding="async">'
      : '';
    return (
      '<div class="leaves-patio-eisku__cell' +
      (featured ? ' leaves-patio-eisku__cell--feature' : '') +
      '"' +
      (clone ? ' aria-hidden="true"' : '') +
      '>' +
      '<a class="leaves-patio-eisku__link" href="' +
      escapeAttr(scene.href) +
      '"' +
      (clone ? ' tabindex="-1"' : '') +
      '>' +
      '<span class="leaves-patio-eisku__media' +
      (featured ? ' leaves-patio-eisku__media--feature' : '') +
      '">' +
      img +
      '<h3 class="leaves-patio-eisku__name">' +
      escapeHtml(scene.title) +
      '</h3></span></a></div>'
    );
  }

  /** Match left media HEIGHT to right stack; width follows column (not square). */
  function syncFeatureHeight(root) {
    if (!root || window.innerWidth < 900) return;
    var stack = root.querySelector('.leaves-patio-eisku__stack');
    var featureMedia = root.querySelector(
      '.leaves-patio-eisku__feature .leaves-patio-eisku__media'
    );
    var featureCell = root.querySelector('.leaves-patio-eisku__feature .leaves-patio-eisku__cell');
    if (!stack || !featureMedia || !featureCell) return;

    featureMedia.style.width = '100%';
    featureMedia.style.height = '';
    featureMedia.style.aspectRatio = 'auto';
    void root.offsetHeight;

    var stackH = stack.getBoundingClientRect().height;
    var nameEl = featureCell.querySelector('.leaves-patio-eisku__name');
    var chrome = nameEl ? nameEl.getBoundingClientRect().height : 0;
    var mediaH = Math.floor(stackH - chrome);
    if (mediaH < 120) return;

    featureMedia.style.width = '100%';
    featureMedia.style.height = mediaH + 'px';
    featureMedia.style.aspectRatio = 'auto';
  }

  function stickyHeaderHeight() {
    var header = document.querySelector('#header-component');
    if (!header) return 0;
    var section = header.closest('.header-section') || header;
    var pos = window.getComputedStyle(section).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    var h = section.getBoundingClientRect().height;
    return h > 0 ? Math.ceil(h) : 0;
  }

  function fitToViewport(root) {
    if (!root) return;
    root.style.transform = '';
    root.style.marginBottom = '';

    var intro = root.querySelector('.leaves-patio-eisku__intro');
    var band = root.querySelector('.leaves-patio-eisku__band');
    var stack = root.querySelector('.leaves-patio-eisku__stack');
    var featureMedia = root.querySelector('.leaves-patio-eisku__feature .leaves-patio-eisku__media');
    var smallMedia = root.querySelectorAll('.leaves-patio-eisku__stack .leaves-patio-eisku__media');

    function resetFit() {
      if (intro) {
        intro.style.marginLeft = '';
        intro.style.marginRight = '';
      }
      if (band) {
        band.style.width = '';
        band.style.gridTemplateColumns = '';
      }
      if (stack) {
        stack.style.width = '';
        stack.style.gridTemplateColumns = '';
      }
      Array.prototype.forEach.call(smallMedia, function (media) {
        media.style.width = '';
        media.style.height = '';
        media.style.aspectRatio = '';
      });
      if (featureMedia) {
        featureMedia.style.width = '';
        featureMedia.style.height = '';
        featureMedia.style.aspectRatio = '';
      }
    }

    function applyHeights(height) {
      Array.prototype.forEach.call(smallMedia, function (media) {
        media.style.width = '100%';
        media.style.height = height + 'px';
        media.style.aspectRatio = 'auto';
      });
    }

    if (window.innerWidth < 900) {
      resetFit();
      return;
    }

    resetFit();
    syncFeatureHeight(root);

    var sample = smallMedia.length ? smallMedia[0] : null;
    var colW = sample ? sample.getBoundingClientRect().width : 0;
    if (!sample || colW < 80) return;

    var host = root.closest('[data-section-id="leaves-e165"]');
    var hostStyle = host ? window.getComputedStyle(host) : null;
    var padTop = hostStyle ? parseFloat(hostStyle.paddingTop) || 0 : 0;
    var padBottom = hostStyle ? parseFloat(hostStyle.paddingBottom) || 0 : 0;
    var vh = window.innerHeight || 800;
    var squareH = sample.getBoundingClientRect().height || colW;
    var contentH = Math.ceil(root.getBoundingClientRect().height + padTop + padBottom);
    if (contentH <= vh + 2) return;

    var minH = Math.max(120, Math.round(colW * 0.78));
    var cardH = Math.floor(squareH - (contentH - vh) / 2 - 8);
    if (cardH > squareH) cardH = Math.floor(squareH);
    if (cardH < minH) cardH = minH;
    applyHeights(cardH);
    syncFeatureHeight(root);
  }

  function wireSohubCta(trigger, bits) {
    var RISE = 48;
    var TWEEN = 0.5;
    var STAGGER = 0.1;
    var n = bits.length;
    var total = TWEEN + STAGGER * Math.max(0, n - 1);
    var shown = 0;
    var last = 0;
    var running = false;

    function rawProgress() {
      var rect = trigger.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      /* Fade while the heading travels through the middle of the screen.
         Done once it sits in the upper third, so the reading position is not blank. */
      var startTop = vh * 0.98;
      var endTop = vh * 0.36;
      var p = (startTop - rect.top) / Math.max(1, startTop - endTop);
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      return p;
    }

    function apply(progress) {
      var time = progress * total;
      var i;
      for (i = 0; i < n; i++) {
        var local = (time - i * STAGGER) / TWEEN;
        if (local < 0) local = 0;
        if (local > 1) local = 1;
        var eased = 1 - (1 - local) * (1 - local);
        bits[i].style.opacity = String(eased);
        bits[i].style.transform = 'translate3d(0,' + (RISE * (1 - eased)).toFixed(2) + 'px,0)';
      }
    }

    var done = false;

    function finish() {
      if (done) return;
      done = true;
      apply(1);
      window.removeEventListener('scroll', kick);
      window.removeEventListener('resize', kick);
    }

    function frame(now) {
      if (done) return;
      if (!last) last = now;
      var dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      var target = rawProgress();
      if (target < shown) target = shown;
      shown += (target - shown) * (1 - Math.exp(-dt / 0.16));
      if (Math.abs(target - shown) < 0.004) shown = target;
      if (shown > 1) shown = 1;
      apply(shown);
      if (shown >= 1) {
        finish();
        running = false;
        return;
      }
      if (shown !== target) {
        window.requestAnimationFrame(frame);
      } else {
        running = false;
        last = 0;
      }
    }

    function kick() {
      if (done || running) return;
      running = true;
      last = 0;
      window.requestAnimationFrame(frame);
    }

    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    kick();
  }

  /**
   * sohub "Don't be shy" — copied from their GSAP call, then checked against
   * the live page (section 1080px, lines settled after the 1s scrub):
   *   timeline({ scrollTrigger:{ trigger, start:"25% 80%", end:"50% center", scrub:1 }})
   *     .fromTo(".cta-anim", { y:"3rem", opacity:0 }, { y:0, opacity:1, stagger:0.1 })
   * Their trigger is a full-screen section. Default tween is 0.5s, power1.out.
   * scrub:1 retargets with expo ease. Opacity and y share that eased value.
   */
  function wireIntroReveal(root) {
    if (!root || root.getAttribute('data-reveal') === '1') return;
    var trigger = root.querySelector('.leaves-patio-eisku__intro') || root;
    var bits = trigger.querySelectorAll(
      '.leaves-patio-eisku__label, .leaves-patio-eisku__line, .leaves-patio-eisku__lead'
    );
    if (!bits.length) return;
    root.setAttribute('data-reveal', '1');

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      Array.prototype.forEach.call(bits, function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    wireSohubCta(trigger, bits);
  }

  function bindRail(root) {
    var viewport = root.querySelector('.leaves-patio-eisku__viewport');
    var track = root.querySelector('.leaves-patio-eisku__grid');
    var story = root.querySelector('.leaves-patio-eisku__story');
    var slides = root.querySelectorAll('.leaves-patio-eisku__grid .leaves-patio-eisku__cell');
    var prev = root.querySelector('.leaves-patio-eisku__arrow--prev');
    var next = root.querySelector('.leaves-patio-eisku__arrow--next');
    if (!viewport || !track || slides.length < 2) return;
    var count = slides.length / 2;
    var index = 0;
    var slideW = 0;
    var gap = 8;
    var gen = 0;

    function visibleCount() {
      var w = viewport.getBoundingClientRect().width;
      if (w >= 1200) return 3.67;
      if (w >= 800) return 2.2;
      return 1.12;
    }

    function measure() {
      var visible = visibleCount();
      var vw = viewport.getBoundingClientRect().width;
      if (!vw) return;
      var gaps = Math.max(0, Math.ceil(visible) - 1);
      slideW = Math.max(1, Math.round((vw - gap * gaps) / visible));
      var photoH = Math.round(slideW * 499 / 384);
      Array.prototype.forEach.call(slides, function (slide) {
        slide.style.flex = '0 0 ' + slideW + 'px';
        slide.style.width = slideW + 'px';
        slide.style.height = photoH + 'px';
        var media = slide.querySelector('.leaves-patio-eisku__media');
        if (media) {
          media.style.height = photoH + 'px';
          media.style.aspectRatio = 'auto';
        }
      });
      if (story) {
        story.style.left = slideW - 1 + 'px';
        story.style.width = slideW + gap * 2 + 2 + 'px';
        story.style.height = photoH + 'px';
      }
    }

    function place(i, animate) {
      var token = ++gen;
      var reduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.style.transition = animate === false || reduce ? 'none' : '';
      track.style.transform = 'translate3d(' + -i * (slideW + gap) + 'px,0,0)';
      if (animate === false || reduce) return;
      function done(e) {
        if (e.propertyName !== 'transform') return;
        track.removeEventListener('transitionend', done);
        if (token !== gen) return;
        if (index >= count) {
          index -= count;
          place(index, false);
        }
      }
      track.addEventListener('transitionend', done);
    }

    function go(delta) {
      if (!slideW) return;
      var reduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (delta < 0 && index === 0) {
        index = count;
        place(index, false);
        if (!reduce) void track.offsetWidth;
      }
      index += delta;
      if (reduce) {
        if (index >= count) index -= count;
        if (index < 0) index += count;
        place(index, false);
        return;
      }
      place(index, true);
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    window.addEventListener('resize', function () {
      measure();
      place(index, false);
    });
    measure();
    place(0, false);
  }

  function build(section, scenes) {
    var cards = scenes.filter(function (s) {
      return s && s.image;
    });
    if (cards.length < 6) return false;

    var old = section.querySelector('.leaves-patio-eisku');
    if (old) old.remove();

    var flex = section.querySelector('.leaves-flex-section') || section;
    var title = 'Which scene do you want to decorate?';
    var story =
      '<div class="leaves-patio-eisku__story">' +
      '<div class="leaves-patio-eisku__story-inner">' +
      '<div class="leaves-patio-eisku__arrows">' +
      '<button type="button" class="leaves-patio-eisku__arrow leaves-patio-eisku__arrow--prev" aria-label="Previous">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M14 6l-6 6 6 6"/></svg>' +
      '</button>' +
      '<button type="button" class="leaves-patio-eisku__arrow leaves-patio-eisku__arrow--next" aria-label="Next">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M10 6l6 6-6 6"/></svg>' +
      '</button></div>' +
      '<p class="leaves-patio-eisku__eyebrow">Choose a scene</p>' +
      '<h2 class="leaves-patio-eisku__title">' +
      escapeHtml(title) +
      '</h2>' +
      '<p class="leaves-patio-eisku__note">Choose a scene to start configuring.</p>' +
      '<a class="leaves-patio-eisku__cta" href="/pages/configure-v2">Start configuring</a>' +
      '</div></div>';

    var root = document.createElement('div');
    root.className = 'leaves-patio-eisku';
    root.setAttribute('data-leaves-patio-eisku', '');
    root.setAttribute('data-fixed-story', '1');

    var looped = cards.concat(cards);
    root.innerHTML =
      '<div class="leaves-patio-eisku__rail">' +
      '<div class="leaves-patio-eisku__viewport">' +
      '<div class="leaves-patio-eisku__grid">' +
      looped
        .map(function (s, index) {
          return cellHtml(s, false, index >= cards.length);
        })
        .join('') +
      '</div></div>' +
      story +
      '</div>';

    Array.prototype.forEach.call(flex.children, function (child) {
      if (child === root) return;
      hideOriginal(child);
    });
    flex.insertBefore(root, flex.firstChild);
    section.classList.add('leaves-patio-eisku-host');
    bindRail(root);
    wireIntroReveal(root);
    root.setAttribute('data-reveal', '1');

    function layout() {
      fitToViewport(root);
    }

    var imgs = root.querySelectorAll('img');
    var pending = imgs.length;
    function done() {
      layout();
      window.requestAnimationFrame(function () {
        layout();
        window.setTimeout(layout, 120);
        window.setTimeout(layout, 400);
      });
    }
    if (!pending) {
      done();
    } else {
      Array.prototype.forEach.call(imgs, function (img) {
        function settle() {
          pending -= 1;
          if (pending <= 0) done();
        }
        if (img.complete) {
          if (img.naturalWidth === 0) img.removeAttribute('src');
          settle();
        } else {
          img.addEventListener('load', settle);
          img.addEventListener('error', function () {
            img.removeAttribute('src');
            settle();
          });
        }
      });
      window.setTimeout(done, 900);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var stackEl = root.querySelector('.leaves-patio-eisku__stack');
      if (stackEl) {
        var roTimer = 0;
        var ro = new ResizeObserver(function () {
          window.clearTimeout(roTimer);
          roTimer = window.setTimeout(layout, 50);
        });
        ro.observe(stackEl);
      }
    }
    return true;
  }

  function run() {
    var section = findSection();
    if (!section) return false;
    moveAboveVideo(section);

    var existing = section.querySelector('.leaves-patio-eisku');
    var firstName = existing && existing.querySelector('.leaves-patio-eisku__grid .leaves-patio-eisku__name');
    if (
      existing &&
      existing.querySelector('.leaves-patio-eisku__rail') &&
      !existing.querySelector('.leaves-patio-eisku__split') &&
      existing.getAttribute('data-fixed-story') === '1' &&
      existing.querySelector('.leaves-patio-eisku__rail > .leaves-patio-eisku__story') &&
      firstName &&
      /umbrella/i.test(textOf(firstName))
    ) {
      existing.style.transform = '';
      existing.style.marginBottom = '';
      if (existing.getAttribute('data-reveal') !== '1') {
        wireIntroReveal(existing);
        existing.setAttribute('data-reveal', '1');
      }
      return true;
    }

    var scenes = collectScenes(section);
    if (!pickFeatured(scenes)) return false;
    if (scenes.filter(function (s) { return s.image; }).length < 6) return false;
    return build(section, scenes);
  }

  function boot() {
    run();
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var ok = run();
      if (ok || tries > 80) {
        window.clearInterval(timer);
        if (!ok) {
          window.setTimeout(run, 1200);
          window.setTimeout(run, 3000);
          window.setTimeout(run, 6000);
        } else {
          window.addEventListener(
            'resize',
            function () {
              var root = document.querySelector('.leaves-patio-eisku');
              if (root) fitToViewport(root);
            },
            { passive: true }
          );
        }
      }
    }, 180);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
